import React, { useEffect } from 'react';

import { withRouter } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';

const Logout = (props) => {
    const { oktaAuth } = useOktaAuth();

    const handleLogout = () => {
        let token = oktaAuth?.authStateManager?._authState?.idToken?.idToken;
        localStorage.clear('state');
        if (token) {
            window.location.href = `${process.env.REACT_APP_LOGOUT_BASE}?id_token_hint=${token}`;
        } else {
            window.location.href = process.env.REACT_APP_LOGOUT_BASE;
        }
    }

    useEffect(() => {
        handleLogout()
    }, [])

    return <>
    </>
};

export default withRouter(Logout);

